
<template>
<div>
    <div class="row" v-if="$gate.isAdmin() || $gate.isReception()  || $gate.isManager() || $gate.isSupervisor()">
            <div class="col-md-12 row">
                <div class="col-md-6 mt-2">
                    <label>Date From</label>
                    <input type="date" v-model="filters.date_1" class="form-control" :disabled="(filters.receipt !== '' && filters.receipt != null) || (filters.parent !== '' && filters.parent != null)">
                    <small v-if="(filters.receipt !== '' && filters.receipt != null) || (filters.parent !== '' && filters.parent != null)" class="text-muted">Date filter is ignored when searching by receipt number or parent</small>
                </div>
                <div class="col-md-6 mt-2">
                    <label>Date To</label>
                    <input type="date" v-model="filters.date_2" class="form-control" :disabled="(filters.receipt !== '' && filters.receipt != null) || (filters.parent !== '' && filters.parent != null)">
                    <small v-if="(filters.receipt !== '' && filters.receipt != null) || (filters.parent !== '' && filters.parent != null)" class="text-muted">Date filter is ignored when searching by receipt number or parent</small>
                </div>
                <div class="col-md-6 mt-2">
                    <label>Receipt #</label>
                    <input type="number" v-model="filters.receipt" class="form-control" placeholder="Receipt#" >
                </div>
                <div class="col-md-6 mt-2">
                    <label>Parent</label>
                    <model-list-select :list="parents"
                                      v-model="selectedParent"
                                      option-value="value"
                                      option-text="text"
                                      placeholder="Type to search parent (min 2 characters)"
                                      @searchchange="debouncedFetchParents">
                    </model-list-select>
                </div>
                <div class="col-md-6 mt-2" v-if="false">
                    <select v-model="filters.user" class="form-control" >
                        <option value="" disabled selected>All Staff</option>
                        <option v-for="user in users" :value="user.value" :key="user.value"> {{user.text}} </option>
                    </select>
                </div>

                <div class="col-md-12 mt-2">
                    <button class="btn btn-primary float-right" @click="endofday()" :disabled="loading">
                        <span v-if="loading" class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                        Filter Receipts
                    </button>
                </div>

            </div>
            <div class="col-md-12 mt-2">
                <!-- Initial load message -->
                <div v-if="!hasSearched" class="alert alert-info text-center">
                    <strong>Please select a filter to display receipts</strong>
                </div>
                
                <!-- Loading indicator -->
                <div v-else-if="loading" class="text-center mt-4">
                    <div class="spinner-border text-primary" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                    <p class="mt-2">Loading receipts...</p>
                </div>
                
                <!-- No receipts found message -->
                <div v-else-if="!loading && transactions.length === 0" class="alert alert-warning text-center">
                    <strong>No receipts found for the selected filter</strong>
                </div>
                
                <!-- Receipts table -->
                <table v-else class="table table-bordered">
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Transaction Number</th>
                            <th>Payment Method</th>
                            <th>Item</th>
                            <th>Notes</th>
                            <th>Status</th>
                            <th>Taxable</th>
                            <th>Discount</th>
                            <th>VAT 5%</th>
                            <th>Total</th>
                            <th>Customer</th>
                            <th>Action</th>
                            <!-- <th>Cashier</th> -->
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="transaction in transactions" :key="transaction.id">
                            <td> {{transaction.date}} </td>
                            <td> SUA - {{transaction.id}} </td>
                            <td> {{transaction.payment}} </td>
                            <td> {{transaction.quantity}} </td>
                            <td> {{transaction.notes}} </td>
                            <td> {{transaction.status}} </td>
                            <td> {{transaction.taxable}} </td>
                            <td> {{transaction.discount}} </td>
                            <td> {{transaction.vat}} </td>
                            <td> {{transaction.total}} </td>
                            <td> {{transaction.customer}} </td>
                            <td>
                                <button class="btn btn-primary" @click="reprint(transaction.id)" data-toggle="modal" :data-target="'#vmbc_modal'+transaction.id"><i class="fa fa-print"></i></button>

                                <div :id="'vmbc_modal'+transaction.id" class="modal fade" role="dialog">
                                <div class="modal-dialog modal-lg">

                                    <!-- Modal content-->
                                    <div class="modal-content">
                                    <div class="modal-header">
                                        <h4 class="modal-title">KUPS - {{transaction.id}} </h4>
                                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                                    </div>
                                    <div class="modal-body" id="print" v-for="print in prints" :key="print.id">

                                        <div><center>StepUp Academy</center></div>
                                        <div><center>113 Apex Atrium Motor City, Dubai, UAE</center></div>
                                        <div class="mt-2">
                                            <div><center>04 453 4360</center></div>
                                            <div><center>info@stepup.ae</center></div>
                                            <div><center>https://stepup.ae</center></div>
                                        </div>
                                        <div class="mt-2">
                                            <div><center>TRN: 1002540945100003</center></div>
                                        </div>
                                        <div class="mt-2">
                                            <div><center>Tax Invoice</center></div>
                                        </div>
                                        <div class="mt-2">
                                            <div><center>Invoice #: STEP-{{print.id}}</center></div>
                                        </div>
                                        <hr>
                                            <div><center>Served By: {{print.staff}}</center></div>
                                            <div><center>Date Purchased: {{ print.created_at }} </center></div>
                                            <div v-if="print.venuename"><center>Location: {{ print.venuename }} </center></div>

                                        <hr>
                                        <table class="table table-bordered table-responsive">
                                            <thead>
                                                <tr>
                                                    <th width='70%' class="text-center">Product</th>
                                                    <th width='8%' class="text-center">Rate Incl Vat</th>
                                                    <th width='8%' class="text-center">QTY</th>
                                                    <th width='8%' class="text-center">Vat</th>
                                                    <th width='8%' class="text-center">Disc</th>
                                                    <th width='8%' class="text-center">Total Incl Vat</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="cart in print.items" v-bind:key="cart.id">
                                                    <td class="text-center"><strong>{{cart.productname}}</strong>
                                                        <div><small>{{cart.optionname}}</small></div> <div v-if="cart.notes !== null">( {{cart.notes}} )</div>
                                                    </td>
                                                    <td class="text-center"><center>{{cart.price}}</center></td>
                                                    <td class="text-center"><center>{{cart.quantity}}</center></td>
                                                    <td class="text-center"><center> {{ parseFloat(vatTotal(cart)).toFixed(2) }}
                                                        <!-- {{ parseFloat(cart.vat).toFixed(2) }} -->
                                                        </center></td>
                                                    <td class="text-center"><center>{{ parseFloat(cart.discount).toFixed(2) }}</center></td>
                                                    <td class="text-center"><center> {{ parseFloat(itemTotal(cart)).toFixed(2) }}
                                                        <!-- {{ parseFloat(cart.total).toFixed(2) }} -->
                                                        </center></td>
                                                </tr>
                                            </tbody>
                                        </table>

                                        <div class="mt-2 text-right">
                                            <hr>
                                            <p>Taxable Value: {{ print.amount_excl }} AED</p>
                                            <p v-if="print.discount !== 0.00">Total Discount: {{ print.discount }} AED</p>
                                            <p>Vat 5%: {{ print.vat }} AED</p>
                                            <p>Total Incl Vat: {{ print.amount_incl }} AED</p>

                                            <p>Payment: {{ totalPayment }} AED</p>

                                            <p v-if="print.paymentChange > 0">Change: {{ print.paymentChange }} AED</p>

                                            <p>Paid: {{ print.payment_type }} </p>
                                        </div>




                                    </div>
                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-success" @click="print"><i class="fa fa-print"></i></button>
                                    </div>
                                    </div>

                                </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
    </div>
    <div class="row" v-else>
        <notfound></notfound>
    </div>

</div>
</template>

<script>
import { ModelListSelect } from 'vue-search-select'
import { debounce } from 'lodash'
export default {
    components: {
      ModelListSelect
    },
    data(){
        return {
            transactions:[],
            transactionsCancelled: [],
            users:[],
            parents:[],
            selectedParent: null,
            loading: false,
            hasSearched: false,
            filters: {
                date_1: new Date().toISOString().substr(0, 10),
                date_2: new Date().toISOString().substr(0, 10),
                user_id: this.$root.id,
                name: this.$root.staffname,
                receipt: '',
                parent: '',
                notes: '',
                draw: 0,
                user: ''
            },
            prints:[],
            tax: [],
            myDate: this.$root.myDate
        }
    },
    created(){
        this.getusers();
        this.debouncedFetchParents = debounce(this.fetchParents, 300);
    },
    watch: {
        selectedParent(v) {
            // Handle both object {value, text} and primitive (number/string) from vue-search-select
            if (v == null || v === '') {
                this.filters.parent = '';
            } else if (typeof v === 'object' && v && v.value != null) {
                this.filters.parent = v.value;
            } else {
                this.filters.parent = v;
            }
        }
    },
    methods: {
        endofday(url = './api/Report/transaction') {
            this.loading = true;
            this.hasSearched = true;
            this.filters.draw++
            axios
            .get(url, {params:this.filters})
            .then((result) => {
                console.log(result.data)
                this.transactions = result.data.transaction
                this.transactionsCancelled = result.data.transactioncancelled
                this.loading = false;
            }).catch((err) => {
                console.log(err)
                this.loading = false;
            });
        },
        fetchParents(searchQuery) {
            if (searchQuery.length < 2) {
                // Keep the selected parent in the list so the dropdown can resolve and display it
                // (searchchange('') often fires after selection, which would otherwise clear parents)
                if (this.selectedParent != null && this.selectedParent !== '') {
                    const isObj = typeof this.selectedParent === 'object' && this.selectedParent && 'value' in this.selectedParent;
                    if (isObj) {
                        this.parents = [this.selectedParent];
                    } else {
                        const found = this.parents.find(p => (p && p.value) === this.selectedParent || p === this.selectedParent);
                        this.parents = found ? [found] : [{ value: this.selectedParent, text: String(this.selectedParent) }];
                    }
                } else {
                    this.parents = [];
                }
                return;
            }
            axios.get('./api/Report/parents', { params: { q: searchQuery } })
                .then((res) => {
                    this.parents = res.data.parents || [];
                })
                .catch(() => { this.parents = []; });
        },
        getusers() {
            axios
            .get('./api/Report/users')
            .then((result) => {
                console.log(result.data)
                this.users = result.data.users
            }).catch((err) => {
                console.log(err)
            });
        },
        reprint(id) {
            axios
            .get('./api/reprint/'+ id)
            .then((result) => {
                console.log(result)
                this.prints = result.data.options
                this.tax = result.data.tax
            }).catch((err) => {
                console.log(err)
            });
        },
        vatTotal(item){
                return (((item.quantity * item.price) - item.discount) / this.tax_vat_one) * this.tax_vat
        },
        itemTotal(item){
                    return (item.quantity * item.price) - item.discount
        },
        print() {
            var divPrint = document.getElementById('print')
            window.document.write(divPrint.outerHTML)
            window.print()
            window.close()
            window.location.assign('/Re-Print-Receipt');
        }
    },
    computed: {
        tax_vat() {
           return this.tax.reduce((total, item) => {
               return total + Number(item.Setting_value / 100)
           }, 0);
        },
        tax_vat_one() {
            return this.tax_vat + 1
        },
        totalPayment() {
            return this.prints.reduce((total, item) => {
                return total + Number(item.card) + Number(item.cash) + Number(item.bank) + Number(item.cheque) + Number(item.paymentChange)
            }, 0);
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/js/Report/reprint.vue